import makeStyles from '@mui/styles/makeStyles'

const useStyles: any = makeStyles(theme => ({
  invalid: {
    borderColor: theme.palette.error.light,
  },
  valid: {
    borderColor: theme.palette.success.light,
  },
}))

export const useMassOrderCoveredColor = () => {
  const classes = useStyles()

  return (valid: boolean) => {
    if (valid === true) {
      return classes.valid
    }
    return classes.invalid
  }
}
